var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.imageFiles.length
    ? _c(
        "picture",
        [
          _vm._l(_setup.imageFiles.slice(0, -1), function (imageFile, index) {
            return _c("source", {
              key: `${imageFile.file.url}-${index}`,
              attrs: {
                type: `image/${imageFile.file_format}`,
                srcset: imageFile.file.url,
              },
            })
          }),
          _vm._v(" "),
          _c("source", {
            attrs: {
              type: `image/${_setup.lastImageFile.file_format}`,
              srcset: _setup.lastImageFile.file.url,
            },
          }),
          _vm._v(" "),
          _c(
            "img",
            _vm._b(
              {
                class: _vm.imgClass,
                style: _setup.imgStyle,
                attrs: {
                  src: _setup.lastImageFile.file.url,
                  "data-lazy-src": _vm.dataLazySrc
                    ? _setup.lastImageFile.file.url
                    : undefined,
                  alt: _setup.imgAlt,
                },
              },
              "img",
              _vm.$attrs,
              false
            )
          ),
        ],
        2
      )
    : _c(
        "img",
        _vm._b(
          {
            class: _vm.imgClass,
            style: _setup.imgStyle,
            attrs: {
              src: _setup.fallbackSrc,
              "data-lazy-src": _vm.dataLazySrc ? _setup.fallbackSrc : undefined,
              alt: _setup.imgAlt,
            },
          },
          "img",
          _vm.$attrs,
          false
        )
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }